module.exports = __webpack_public_path__ + "static/img/img2.376f1e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img2.png
// module id = 2547
// module chunks = 1